export class ReportFilter {
  account: string;
  merchantObj: any;
  merchantId: string;
  startDateId: string;
  endDateId: string;
  serviceId: string;
  status: string;
  operationType: string;
  approvalCode: string;
  affiliation: string;
  dateRange: any;
  accountingNature: string;
  cardBrand: string;
}
